module.exports = __webpack_public_path__ + "static/media/plan-B5b-desktop-sc.aedb6e01.png";